const DSN =
  'https://cf72eadfdce34e13a3e54618de4817f9@o125120.ingest.sentry.io/275595';

export default {
  DSN,
};
